export default function NotFound() {
  return (
    <main className="not-found">
      <h1>404</h1>
      <p>Seite nicht gefunden.</p>
    </main>
  );
}
